export const TranslationIdMap = '';

// TODO: __CONTINUE and __PLEASE_ENTER_A_DISPOSITION_ are unused and can be removed
export const TranslationKeyMap = {
    '_121_CANCEL': 'Cancel',
    '_763_CLOSE': 'Close',
    '__GUIDE_CONFIRMATION': 'Guide Confirmation',
    '__SELECT_A_DIFFERENT_GUIDE': 'Select a Different Guide',
    '__CONTINUE': 'Continue',
    '__PLEASE_ENTER_A_DISPOSITION_': 'Please enter a disposition for choosing this option',
    '__THERE_IS_NO_RECOMMENDED_GUIDE_': 'There is no recommended guide.',
    '_11343_SELECT_GUIDE_SUBTITLE': 'Select a conversation guide for this coaching session',
    '_11344_RECOMMENDED_GUIDE': 'Recommended Guide',
    '_11345_AVAILABLE_GUIDES': 'Available Guides',
    '_11346_SECTIONS': 'Sections',
    '_11347_QUESTIONS': 'Questions',
    '_11348_WHY_DIFFERENT_GUIDE': 'Why are you selecting a different guide?',
    '_11349_DISPOSITION_PLACEHOLDER': 'e.g., The performer has already completed the draft commitment phase...',
    '_11350_CONFIRM_GUIDE': 'Confirm Guide',
    '_11351_CONFIRM_SELECTED_GUIDE': 'Confirm Selected Guide',
    '_11353_RECOMMENDED': 'Recommended'
};
